module.exports = __webpack_public_path__ + "img/answer-c4-4.a4d2e6da.png";